import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyAddon } from "../../../../actions/mods_factory/addonsActions";
import { selectAddonEntities, selectAddonIds, setEditId } from "../../../../store/mods_factory/addonsSlice";

import {Image, message, Spin} from "antd";
import { LikeOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import IconText from "../../../../componets/IconText";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import Meta from "../../Users/_partials/_Meta";
import { selectUserEntities } from "../../../../store/mods_factory/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectAddonIds);
  const items     = useAppSelector(selectAddonEntities);
  const users     = useAppSelector(selectUserEntities);
  const count     = useAppSelector(state => state.modsFactory.addons.count);
  const error     = useAppSelector(state => state.modsFactory.addons.error);
  const status    = useAppSelector(state => state.modsFactory.addons.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAddon(id));

    if (destroyAddon.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyAddon.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderList = (id: EntityId) => {
    const item = items[id];

    if (!item) {
      return;
    }
    const user = users[item.user_id];
    const formattedCreatedAt = formattedDate(item.created_at);

    return (
      <CardImage
        key={item.id}
        size='medium'
        className='v-addon-card'
        image={item.image_url}
        title={item.title}
        link={item.url}
        stats={[
          <Image src={item.ico_url} width={12} height={12} preview={false} />,
          <IconText icon={LikeOutlined} text={item.likes_count} />,
          <IconText icon={MessageOutlined} text={item.comments_count} />
        ]}
        options={[
          <ButtonEdit key={`edit-${item.id}`} onClick={() => onClickEdit(item.id)} />,
          <ButtonDestroy key={`destroy-${item.id}`} onClick={() => onClickDestroy(item.id)} />
        ]}
      >
        {<Meta user={user} size='xsmall' className='v-addon-card--meta-user' />}

        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      <div className='v-addons-list'>
        {ids && ids.map(renderList)}
      </div>

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
